import React from "react";
import { Link } from "react-router-dom";

export default function Teams() {
  return (
    <>
      <section className="team-member-section ptb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-8">
              <div className="section-heading text-center mb-4">
                <h2>About Us</h2>
                <p className="lead">
                  Following reasons show advantages of adding AppCo to your lead
                  pages, demos and checkouts
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                <div className="team-image">
                  <img
                    src="assets/img/team-4.jpg"
                    alt="Team Members"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Edna Mason</h5>
                  <h6>Senior Designer</h6>
                  <ul className="list-inline team-social social-icon my-4 text-white">
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-facebook"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-twitter"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-github"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-dribbble"></span>
                      </Link>
                    </li>
                  </ul>
                  <a
                    href="tteam-details"
                    target="_blank"
                    className="btn app-store-btn"
                  >
                    View details
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                <div className="team-image">
                  <img
                    src="assets/img/team-1.jpg"
                    alt="Team Members"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Edna Mason</h5>
                  <h6>Senior Designer</h6>
                  <ul className="list-inline team-social social-icon my-4 text-white">
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-facebook"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-twitter"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-github"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-dribbble"></span>
                      </Link>
                    </li>
                  </ul>
                  <a
                    href="tteam-details"
                    target="_blank"
                    className="btn app-store-btn"
                  >
                    View details
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                <div className="team-image">
                  <img
                    src="assets/img/team-2.jpg"
                    alt="Team Members"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Edna Mason</h5>
                  <h6>Senior Designer</h6>
                  <ul className="list-inline team-social social-icon my-4 text-white">
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-facebook"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-twitter"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-github"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-dribbble"></span>
                      </Link>
                    </li>
                  </ul>
                  <a
                    href="tteam-details"
                    target="_blank"
                    className="btn app-store-btn"
                  >
                    View details
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                <div className="team-image">
                  <img
                    src="assets/img/team-3.jpg"
                    alt="Team Members"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Edna Mason</h5>
                  <h6>Senior Designer</h6>
                  <ul className="list-inline team-social social-icon my-4 text-white">
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-facebook"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-twitter"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-github"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-dribbble"></span>
                      </Link>
                    </li>
                  </ul>
                  <a
                    href="tteam-details"
                    target="_blank"
                    className="btn app-store-btn"
                  >
                    View details
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                <div className="team-image">
                  <img
                    src="assets/img/team-6.jpg"
                    alt="Team Members"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Edna Mason</h5>
                  <h6>Senior Designer</h6>
                  <ul className="list-inline team-social social-icon my-4 text-white">
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-facebook"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-twitter"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-github"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-dribbble"></span>
                      </Link>
                    </li>
                  </ul>
                  <a
                    href="tteam-details"
                    target="_blank"
                    className="btn app-store-btn"
                  >
                    View details
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                <div className="team-image">
                  <img
                    src="assets/img/team-7.jpg"
                    alt="Team Members"
                    className="img-fluid rounded"
                  />
                </div>
                <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Edna Mason</h5>
                  <h6>Senior Designer</h6>
                  <ul className="list-inline team-social social-icon my-4 text-white">
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-facebook"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-twitter"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-github"></span>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="#/">
                        <span className="ti-dribbble"></span>
                      </Link>
                    </li>
                  </ul>
                  <a
                    href="tteam-details"
                    target="_blank"
                    className="btn app-store-btn"
                  >
                    View details
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
